import { Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import RegistrationPage from './pages/RegistrationPage';
import JimRootPage from './pages/JimRootPage';
import KusumotoPage from './pages/KusumotoPage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/register" element={<RegistrationPage />} />
      <Route path="/jim-root" element={<JimRootPage />} />
      <Route path="/kusumoto" element={<KusumotoPage />} />
    </Routes>
  );
}

export default App;